<template>
  <el-dialog
    title="详情"
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    width="600px"
  >
    <div class="dialog_box">
      <el-form ref="form" :model="form" label-width="140px">
        <el-form-item label="预设类型">
          <el-select
            size="small"
            v-model.trim="form.announcementDataType"
            placeholder="请选择"
            disabled
          >
            <el-option label="告知卡" :value="1"></el-option>
            <el-option label="告知栏" :value="2"></el-option>
            <el-option label="告知栏" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称">
          <el-input
            size="small"
            v-model.trim="form.announcementDataName"
          ></el-input>
        </el-form-item>
        <el-form-item label="风险等级" v-if="detail.announcementDataType == 3">
          <el-select
            size="small"
            v-model.trim="form.announcementDataGrade"
            placeholder="请选择"
          >
            <el-option label="一级" :value="1"></el-option>
            <el-option label="二级" :value="2"></el-option>
            <el-option label="三级" :value="3"></el-option>
            <el-option label="四级" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="
            detail.announcementDataType == 2 ? '易发生事故类型' : '风险因素'
          "
        >
          <el-input size="small" v-model.trim="form.riskFactor"></el-input>
        </el-form-item>
        <el-form-item
          :label="
            detail.announcementDataType == 1
              ? '风险类别'
              : detail.announcementDataType == 2
              ? '主要风险因素'
              : '可能导致的事故类型'
          "
        >
          <el-input
            size="small"
            type="textarea"
            v-model.trim="form.typeAccident"
          ></el-input>
        </el-form-item>
        <el-form-item label="管控措施">
          <el-input
            size="small"
            type="textarea"
            v-model.trim="form.controlMeasures"
          ></el-input>
        </el-form-item>
        <el-form-item label="应急措施">
          <el-input
            size="small"
            type="textarea"
            v-model.trim="form.emergencyMeasures"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="edit">
            确定
          </el-button>
          <el-button size="small" @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "RiskNoticeTemplateDefaultDetail",
  components: {},
  props: {
    resize: {
      type: Number,
      default: {
        return: 0
      }
    },
    detail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    //这里存放数据
    return {
      fileUrl: this.$store.state.config.fileUrl,
      showDialog: false,
      form: {}
    };
  },
  //监控data中的数据变化
  watch: {
    resize: function(val) {
      if (val) {
        this.form = this.detail;
        this.showDialog = true;
      }
    }
  },
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    handleClose() {
      this.clearData();
      this.showDialog = false;
    },
    clearData() {
      this.form = {};
    },
    async edit() {
      let req = this.form;
      let res = await this.$Http.editNoticeTemplateDefault(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.handleClose();
        this.$emit("getList");
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
.el-dialog {
  ::v-deep .el-dialog__body {
    padding-top: 0;
  }
}
.edu_pages_content_body_box {
  margin: 0;
  padding: 0;
}
.dialog-footer {
  text-align: right;
}
</style>
